//
//
//
//

export default {
  name: "EmptyPartnerCard"
}
